import React, { useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { I18N, I18NConsumer, GlobalContext } from 'commons';
import { orgId, baseUrl, setPageTitle, qs } from 'utils';
import { Table } from 'reactstrap';
import { Link } from '@reach/router';
import RtfContent from 'containers/general-notification/detail/RtfContent';
import AttachmentImages from 'containers/general-notification/detail/AttachmentImages';
import AttachmentList from 'containers/general-notification/detail/AttachmentList';
import SocialSharing from 'commons/SocialSharing';
import { useFetchEventDetailData } from './api';
import ItemHeader from '../ItemHeader';
import SignUpWidget from '../signUpWidget';
import './event-detail.scss';

export default function EventDetail({ notificationId, location }) {
  const { organization: { orgName = '' } } = useContext(GlobalContext);
  const { event_id } = qs();
  const [{ data: {
    success: isLoadSuccess = false,
    message: errorMessage = '',
    result: {
      eventSubscription: eventData = {},
      ...notificationData
    } = {}
  } = {}
  }, fetchEventDetailData] = useFetchEventDetailData({});

  useEffect(() => {
    fetchEventDetailData({ orgId, notificationId, event_id });
  }, [notificationId]);

  useEffect(() => {
    if (isLoadSuccess) setPageTitle(notificationData.title);
  }, [isLoadSuccess]);

  return (
    <div className="well ssp-well container col-11 event-detail">
      <I18NConsumer>
        {(i18n) => setPageTitle(`${orgName} - ${i18n['eventSubscription.notification.title']}`)}
      </I18NConsumer>
      {isLoadSuccess ?
        <div className="row m-0">
          <div className="col-md-12">
            {notificationData.type &&
            <div className="row box-pd5 gray-bg">
              <div className="col-4 event-detail-back">
                {event_id ?
                  <Link
                    to={`/${orgId}/event?eventId=${eventData.id}`}
                    eb-test="event_detail_link_back"
                    state={(location && location.state) ? { page: location.state.page, pageSize: location.state.pageSize } : { page: 1, pageSize: 25 }}
                  >
                    &lt;<I18N>eventSubscription.notification.link.back</I18N>
                  </Link>
                  :
                  <Link to="../">
                    &lt;<I18N>eventSubscription.notification.link.viewEvents</I18N>
                  </Link>
                }
              </div>
              {
                event_id && eventData.eventSubscriptionWebPage.socialSharing &&
                <div className="col-8 text-right">
                  <SocialSharing
                    url={`${baseUrl}/${orgId}/event/${notificationData.notificationId}?event_id=${eventData.id}`}
                    title={eventData.groupName}
                    description={eventData.groupName}
                    alignment="right"
                  />
                </div>
              }
            </div>
            }

          </div>
          <div className="col-md-8">
            {
              notificationData.eventWebPageStatus === 'Deactive' ?
                <h2>
                  <small><I18N>eventSubscription.notification.message.deactivated</I18N></small>
                </h2>
                :
                <div>
                  <ItemHeader type="detail" notificationObj={notificationData} />
                  {notificationData.type === 2 && notificationData.category &&
                    <div className="text-muted well ssp-well lightgray-bg">
                      <label>{notificationData.category} - {notificationData.event}</label>
                      <Table>
                        <thead>
                          <tr>
                            <th><I18N>eventSubscription.notification.field.urgency</I18N></th>
                            <th><I18N>eventSubscription.notification.field.severity</I18N></th>
                            <th><I18N>eventSubscription.notification.field.certainty</I18N></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr className="active">
                            <td>{notificationData.urgency}</td>
                            <td>{notificationData.severity}</td>
                            <td>{notificationData.certainty}</td>
                          </tr>
                        </tbody>
                      </Table>
                      <label><I18N>eventSubscription.notification.field.instructions</I18N></label>
                      <p>{notificationData.instructions}</p>
                    </div>
                  }
                  <div>
                    <p>{notificationData.textMessage}</p>
                    {notificationData.rtfContent &&
                    <div>
                      <hr />
                      <RtfContent title={notificationData.title} rtfContent={notificationData.rtfContent} />
                    </div>
                    }
                  </div>
                  {notificationData.attachmentFiles && (
                    <AttachmentImages images={notificationData.attachmentFiles.filter(file => file.image)} />
                  )}
                  {notificationData.attachmentFiles && <AttachmentList files={notificationData.attachmentFiles} />}
                </div>
            }
          </div>
          {
            eventData &&
            (eventData.eventSubscriptionWebPage.requireName ||
              eventData.eventSubscriptionWebPage.requireMobile ||
              eventData.eventSubscriptionWebPage.requireEmail) &&
            <div className="col-md-4 signup-box">
              <SignUpWidget eventSubscription={eventData} />
            </div>
          }
        </div>
        :
        <div className="col-md-8">
          {
            errorMessage &&
            <h2>
              <small>{errorMessage}</small>
            </h2>
          }
        </div>
      }
    </div>
  );
}

EventDetail.propTypes = {
  notificationId: PropTypes.string.isRequired
};
